<template>
  <div class="w-100 folder">
    <div class="subfolder" v-if="!root"
         :class="{'available':data.available}"
         @click="data.available?open = !open : undefined">
      <div class="arrow" >
        <inline-svg
          v-if="data.available"
          :class="{'fold':!open}"
          width="15" height="15"
          :src="require('@/assets/images/icons/Icon_DropdownArrow_Down.svg')"/>
        <inline-svg v-else :src="require('@/assets/images/icons/Icon_Lock.svg')"
                    :title="blockedText(data.accessCondition)"
                    width="15" height="15" />
      </div>
      <div class="image">
        <inline-svg :src="require('@/assets/images/icons/Icon_Folder.svg')"
                    class="mr-3"
                    width="20" height="20"/>
      </div>
      <div class="resource-name"> {{data.name}}</div>
      <div>
        <div class="unview" v-if="data.totalUnViewedResources">
          {{data.totalUnViewedResources}}
        </div>
      </div>
    </div>
    <div class="w-100" :class="{'pl-4':!root}" v-if="open || root">
      <ResourceFolder v-on="$listeners"
                      v-for="folder in data.subFolders" :key="folder.id" :data="folder"/>
      <div
           v-for="resource in data.resources" :key="resource.id">
        <a v-if="resource.type === 'LINK' && resource.available"
           class="resource"
           :class="{'available':resource.available}"
           @click="click($event,resource)"
           :href="resource.filename" target="_blank">
          <div class="image">
            <inline-svg v-if="['PDF', 'SHAREPOINT_PDF'].includes(resource.type)"
                        :src="require('@/assets/images/icons/Icon_Acrobat.svg')"
                        width="20" height="20" />
            <inline-svg v-if="resource.type === 'VIDEO'"
                        :src="require('@/assets/images/icons/Icon_Video.svg')"
                        width="20" height="20"/>
            <inline-svg v-if="resource.type === 'IMAGE'"
                        :src="require('@/assets/images/icons/Icon_Picture.svg')"
                        width="20" height="20"/>
            <inline-svg v-if="['EXCEL', 'SHAREPOINT_EXCEL'].includes(resource.type)"
                        :src="require('@/assets/images/icons/Icon_Excel.svg')"
                        width="20" height="20"/>
            <inline-svg v-if="['WORD', 'SHAREPOINT_WORD'].includes(resource.type)"
                        :src="require('@/assets/images/icons/Icon_Word.svg')"
                        width="20" height="20"/>
            <inline-svg v-if="['PPT', 'SHAREPOINT_PPT'].includes(resource.type)"
                        :src="require('@/assets/images/icons/Icon_PowerPoint.svg')"
                        width="20" height="20"/>
            <inline-svg v-if="resource.type === 'LINK'"
                        :src="require('@/assets/images/icons/Icon_Link.svg')"
                        width="20" height="20"/>
          </div>
          <div class="resource-name"> {{resource.name}}</div>
          <div v-if="!resource.available" class="flex-column d-flex">
            <inline-svg :src="require('@/assets/images/icons/Icon_Lock.svg')"
                        :title="blockedText(resource.accessCondition)"
                        width="15" height="15" />
          </div>
          <div v-if="!resource.watched && resource.available" class="unviewed-resource mx-3"></div>
        </a>
        <div v-else @click="click($event,resource)"
             class="resource"
             :class="{'available':resource.available}">
          <div class="image">
            <inline-svg v-if="['PDF', 'SHAREPOINT_PDF'].includes(resource.type)"
                        :src="require('@/assets/images/icons/Icon_Acrobat.svg')"
                        width="20" height="20" />
            <inline-svg v-if="resource.type === 'VIDEO'"
                        :src="require('@/assets/images/icons/Icon_Video.svg')"
                        width="20" height="20"/>
            <inline-svg v-if="resource.type === 'IMAGE'"
                        :src="require('@/assets/images/icons/Icon_Picture.svg')"
                        width="20" height="20"/>
            <inline-svg v-if="['EXCEL', 'SHAREPOINT_EXCEL'].includes(resource.type)"
                        :src="require('@/assets/images/icons/Icon_Excel.svg')"
                        width="20" height="20"/>
            <inline-svg v-if="['WORD', 'SHAREPOINT_WORD'].includes(resource.type)"
                        :src="require('@/assets/images/icons/Icon_Word.svg')"
                        width="20" height="20"/>
            <inline-svg v-if="['PPT', 'SHAREPOINT_PPT'].includes(resource.type)"
                        :src="require('@/assets/images/icons/Icon_PowerPoint.svg')"
                        width="20" height="20"/>
            <inline-svg v-if="resource.type === 'LINK'"
                        :src="require('@/assets/images/icons/Icon_Link.svg')"
                        width="20" height="20"/>
          </div>
          <div class="resource-name"> {{resource.name}}</div>
          <div v-if="!resource.available" class="flex-column d-flex">
            <inline-svg :src="require('@/assets/images/icons/Icon_Lock.svg')"
                        :title="blockedText(resource.accessCondition)"
                        width="15" height="15" />
          </div>
          <div v-if="!resource.watched && resource.available" class="unviewed-resource mx-3"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HelperMixin from '@/mixins/helperMixin';
import store from '@/store';
import { FETCH_FILE, FILE_CONTENT } from '@/store/actions.type';
import { mapGetters } from 'vuex';

export default {
  name: 'ResourceFolder',
  mixins: [HelperMixin],
  computed: {
    ...mapGetters(['currentSession']),
  },
  props: {
    data: {
      type: Object,
      default: null,
    },
    root: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      open: false,
    };
  },
  methods: {
    click(e, resource) {
      if (!resource.available) {
        return;
      }
      if (resource.type === 'LINK') {
        const payload = {
          session: this.currentSession.id,
          resourceId: resource.id,
          fileType: resource.type,
        };
        store.dispatch(FILE_CONTENT, payload).then(() => {
          this.$Progress.finish();
        });
      } else if (['VIDEO', 'PDF', 'IMAGE',
        'SHAREPOINT_EXCEL', 'SHAREPOINT_PPT', 'SHAREPOINT_WORD'].includes(resource.type)) {
        e.preventDefault();
        this.$emit('showResource', resource);
      } else {
        e.preventDefault();
        const payload = {
          session: this.currentSession.id,
          resourceId: resource.id,
          fileName: resource.filename,
        };
        store.dispatch(FETCH_FILE, payload).then(() => {
          this.$Progress.finish();
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.unview{
  display: flex;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 2rem;
  justify-content: center;
  align-items: center;
  border: solid 1px white;
  background-color: var(--primary);
}
.resource {
  display: flex !important;
  align-items: center;
  padding: 0.75rem;
  border-radius: 0.5rem;
  margin-bottom: 0.5rem;
  background-color: var(--secondary-background);
  &.available{
    cursor: pointer;
  }
  .number, .image {
    flex: 0 0 30px;
  }
  .resource-name {
    flex: 1 1 100%;
    overflow: hidden;
  }
  .button {
    flex: 0 0 130px;
  }
  .btn {
    width: 100%;
    line-height: 0.8 !important;
  }
  .unviewed-resource{
    width: 0.6rem;
    height: 0.6rem;
    background-color: var(--primary);
    border-radius: 0.3rem;
  }
}
.folder {
  .subfolder {
    width: 100%;
    display: inline-grid !important;
    grid-template-columns: 1fr 1fr 10fr 1fr;
    align-items: center;
    padding: 0.75rem;
    border-radius: 0.5rem;
    margin-bottom: 0.5rem;
    background-color: var(--secondary-background);
    &.available{
      cursor: pointer;
    }
  }
  .image {
    flex: 0 0 30px;
  }
  .resource-name {
    flex: 1 1 100%;
    overflow: hidden;
  }
  .button {
    flex: 0 0 130px;
    .btn {
      width: 100%;
    }
  }
}
.arrow{
  display: flex;
  border: none;
  margin-right: 1rem;
}
.arrow svg{
  margin: auto;
  transform: rotate(0deg);
  transition: transform 300ms;
}
.arrow .fold{
  transform: rotate(-90deg);
}
</style>
